module.exports = __webpack_public_path__ + "static/media/DCC-Logo.94421ee9.svg";